import React, { useState, useEffect } from "react";

const AddOptoutContact = ({ addOptoutContactCount, addRowData, SetAddRowData }) => {
  const [addOptoutContactRow, setAddOptoutContactRow] = useState(addRowData);

  useEffect(()=>{
    setAddOptoutContactRow(addRowData);
  },[addRowData])

  const handleInputChange = (e, rowIndex) => {
    const { name, type, value, checked } = e.target;
    
    const newValue = type === "checkbox" ? checked : value;
    const updatedRows = addOptoutContactRow.map((row, index) =>
      index === rowIndex ? { ...row, [name]: newValue } : row
    );
    // Update state with new rows data
    SetAddRowData(updatedRows)
  };

  return (
    <div className="identifier${count}">
      <table className="blueTable newTableClass">
        <thead>
          <th>Given Name</th>
          <th>Family Name</th>
          <th>Contact URL</th>
          <th>Opt-Out Expiration Date</th>
          <th>Requestor</th>
          <th>Request Type</th>
        </thead>
        <tbody className="tbodyClass">
            {
                addOptoutContactRow.map((row, index)=>
                    <tr className="identifier">
                    <td>
                      <input
                        type="text"
                        className="input"
                        value={row.givenName}
                        name="givenName"
                        onChange={(e) => handleInputChange(e, index)}
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        value={row.lastName}
                        maxLength={9}
                        name="lastName"
                        onChange={(e) => handleInputChange(e, index)}
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        className="input"
                        value={row.contactUrl}
                        name="contactUrl"
                        onChange={(e) => handleInputChange(e, index)}
                      />
                    </td>
                    <td>
                      <input
                        type="date"
                        className="input"
                        value={row.expirationDt}
                        name="expirationDt"
                        onChange={(e) => handleInputChange(e, index)}
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        className="input"
                        value={row.requestor}
                        name="requestor"
                        onChange={(e) => handleInputChange(e, index)}
                      />
                    </td>
                    <td>
                      <select
                        className="selectclass requestTypeId"
                        name="requestType"
                        value={row.requestType}
                        onChange={(e) => handleInputChange(e, index)}
                      >
                        <option value="Temporary">
                          Data update (temporary suppression)
                        </option>
                        <option value="Permanent">Contact directory suppression</option>
                        <option value="Permanent-GCA">
                          Contact directory AND GCA suppression
                        </option>
                      </select>
                    </td>
                  </tr>)
            }
         
        </tbody>
      </table>
    </div>
  );
};
export default AddOptoutContact;
